import { render, staticRenderFns } from "./FooterNavItem.vue?vue&type=template&id=6362f52a"
import script from "./FooterNavItem.vue?vue&type=script&lang=ts"
export * from "./FooterNavItem.vue?vue&type=script&lang=ts"
import style0 from "./FooterNavItem.vue?vue&type=style&index=0&id=6362f52a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports